import { ProductDepartmentUpdatePage } from "@/features/product-department/pages/ProductDepartmentUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-department/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_department.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDepartmentUpdatePage,
});
